import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsPortalVisitsCountByTimeTab = _resolveComponent("StatisticsPortalVisitsCountByTimeTab")!
  const _component_StatisticsPortalVisitsCountByUsers = _resolveComponent("StatisticsPortalVisitsCountByUsers")!
  const _component_StatisticsVisitsCountTabs = _resolveComponent("StatisticsVisitsCountTabs")!

  return (_openBlock(), _createBlock(_component_StatisticsVisitsCountTabs, null, {
    "first-tab": _withCtx(() => [
      _createVNode(_component_StatisticsPortalVisitsCountByTimeTab, { filter: _ctx.filter }, null, 8, ["filter"])
    ]),
    "second-tab": _withCtx(() => [
      _createVNode(_component_StatisticsPortalVisitsCountByUsers, { filter: _ctx.filter }, null, 8, ["filter"])
    ]),
    _: 1
  }))
}